import script from "./GalleryComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./GalleryComponent.vue?vue&type=script&setup=true&lang=js"

import "./GalleryComponent.vue?vue&type=style&index=0&id=34fa082f&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34fa082f"]])

export default __exports__